<template>
  <div id="mobile">
    <div class="uyu-mobile-header" style="z-index: 200">
      <!-- 公共标题部分 -->
      <div class="uyu-title-logo">
        <img
          src="../../assets/pc/logo.png"
          @click="goMobilePath('/mobile/home')"
          alt=""
        />
        <!-- 细节待完善 修改后放开英文版 -->
        <div class="uyu-language-box">
          <span
            @click="translate('zh')"
            :class="{ 'active-language': lang === 'zh' }"
            >中文</span
          >
          |<span
            @click="translate('en')"
            :class="{ 'active-language': lang === 'en' }"
            >English</span
          >
        </div>
        <div class="uyu-title-button" @click="menuClick">
          <img src="../../assets/mobile/menu.png" alt="" />
        </div>
      </div>
      <!-- menu选择项 -->
      <div class="uyu-menu" v-if="menuShow">
        <div
          class="menu-item"
          @click="goMobilePath(item.path)"
          :key="item.path"
          v-for="item in menuItemList"
        >
          <div class="menu-item-text">{{ $t(item.name) }}</div>
          <img
            class="menu-item-arrow"
            src="../../assets/mobile/arrow.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- uyu-content内容 -->
    <div class="uyu-mobile-content">
      <router-view></router-view>
    </div>
    <a href="tel:020-85532423">
      <div class="mobile-phone-btn" @click="businessStatisClick">
        <img src="../../assets/mobile/mobile-phone.png" alt="" /></div
    ></a>
  </div>
</template>

<script>
import { getLanguage } from "@/lang/index";
export default {
  name: "mobile",
  data() {
    return {
      menuShow: false,
      menuItemList: [
        {
          name: "route.home",
          path: "/mobile/home",
        },
        {
          name: "route.case",
          path: "/mobile/case",
        },
        {
          name: "route.product",
          path: "/mobile/product",
        },
        {
          name: "route.aboutus",
          path: "/mobile/aboutus",
        },
        {
          name: "route.news",
          path: "/mobile/news",
        },
      ],
      tongJiFun: null,
    };
  },
  components: {},
  computed: {
    lang: {
      get() {
        return this.$store.state.app.language;
      },
      set(lang) {
        this.$i18n.locale = lang;
        this.$store.dispatch("app/setLanguage", lang);
      },
    },
  },
  methods: {
    businessStatisClick(){
      this.businessStatis('phoneData')
    },
    menuClick() {
      this.menuShow = !this.menuShow;
    },
    goMobilePath(path) {
      this.menuShow = false;
      this.$router.push(path).catch((err) => err);
    },
    // 语言切换
    translate(lang) {
      if (lang == "zh") {
        this.lang = "zh";
      } else {
        this.lang = "en";
      }
    },
  },
  created() {
    // 获取缓存的语言
    const lang = getLanguage();
    setTimeout(() => {
      this.translate(lang);
      this.lang = lang;
    }, 0);
    // 获取用户IP并存入数据库
    // const mapKey = "F4KBZ-SA2K6-KU3SZ-M35WS-2IBL5-ATFFZ";
    // const url = "https://apis.map.qq.com/ws/location/v1/ip?";
    // this.$jsonp(url, {
    //   key: mapKey,
    //   output: "jsonp",
    // }).then((res) => {
    //   console.log(res.result,'移动Mobile-获取访问用户IP地址');
    // });
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
// .nb-invite-wrap-base{
//   display: none !important;
// }
@import "./mobile.less";
</style>
